import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function SimpleBackdrop() {
  const [open] = React.useState(true);

  return (
    <div>
      <Backdrop sx={{ color: '#fff', zIndex: 9999999999 }} open={open}>
        <CircularProgress color="primary" />
      </Backdrop>
    </div>
  );
}
